export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      user: {
        userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a5',
        name: '管理者 太郎',
        email: 'aaa@aaa.com',
        roleKbn: 1,
        service: {
          serviceUuid: 'サービスUUID',
          serviceName: 'サービス名'
        },
        linkedCmss: [
          {
            linkCMSMstId: 1,
            linkCMSName: '連携CMS名称',
            linkCMSURL: '連携CMS URL'
          }
        ],
        lastLoginAt: 1594880785395
      },
      accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZXYuaW5zcGVjdGlvbi5qaXcuY28uanBcL2FwaVwvdjFcL2xvZ2luXC91c2VyIiwiaWF0IjoxNTgzNzMzNjY1LCJleHAiOjE1ODM4MjAwNjUsIm5iZiI6MTU4MzczMzY2NSwianRpIjoiZW51MnliN09pVVpINWZmUyIsInN1YiI6MjcsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.1PnsyFSJKU6l3citm1ZOb2OxsbbP9VTaA8Itc_5O28k',
      passwordChanged: false,
      timestamp: 1594880785395,
      hash: '298b48bd4e0e05f7f8265ec54a4c6d81902d43b2735d65dfbc77ba1d41f8d78c'
    }
  }
}